(function(){
  'use strict';
  angular.module("irricrops")
    //http://stackoverflow.com/questions/24080018/download-file-from-a-asp-net-web-api-method-using-angularjs
    .directive('downButton', [function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'shared/downbutton/button.tmpl.html',
            scope:{
              dataPdf:"=data",
              disabled:"=disabled",
            },
            controller: ['$scope', '$element', '$attrs', '$timeout', '$http', '$mdDialog',
              function ($scope, $element, $attrs,  $timeout, $http, $mdDialog) {
                $scope.progress = false;
                $scope.text = $attrs.text;

                //debe traer template, error y scope

                var prepare = function () {
                    $scope.progress = true;
                };
                var success = function(){
                    $scope.progress = false;
                };
                var error = function () {
                    $scope.progress = false;
                };

                var DialogController = ['$scope', '$mdDialog', 'parentScope', function($scope, $mdDialog, parentScope) {
                  angular.extend($scope, parentScope.dataPdf.error.scope);
                  $scope.hide = function() {
                    $mdDialog.hide();
                  };
                  $scope.cancel = function() {
                    $mdDialog.cancel();
                  };
                  $scope.answer = function(answer) {
                    $mdDialog.hide(answer);
                  };
                  $scope.print = function(answer) {
                    $mdDialog.hide(answer);
                    fileDownload($attrs.href, parentScope.dataPdf.dataHttp, prepare, success, error );
                  };
                }];

                $scope.showVerificationError = function() {
                  $mdDialog.show({
                    controller: DialogController,
                    templateUrl: $scope.dataPdf.error.template,
                    parent: angular.element(document.body),
                    clickOutsideToClose:true,
                    locals:{parentScope: $scope}
                  })
                  .then(function(answer) {
                    // $scope.status = 'You said the information was "' + answer + '".';
                  }, function() {
                    // $scope.status = 'You cancelled the dialog.';
                  });
                };

                $scope.download = function () {
                  if(!$scope.dataPdf.error.error){
                    fileDownload($attrs.href, $scope.dataPdf.dataHttp,  prepare, success, error );
                  }else{
                    $scope.showVerificationError();
                  }
                };


//TODO usar file.download
                var fileDownload = function(httpPath, data, prepareFn, successFn, errorFn) {
                  // Use an arraybuffer
                  prepareFn();
                  $http.post(httpPath, data, { responseType: 'arraybuffer' })
                    .success( function(data, status, headers) {

                      var octetStreamMime = 'application/octet-stream';
                      var success = false;
                      var blob = {};
                      var url = "";

                      // Get the headers
                      headers = headers();

                      // Get the filename from the x-filename header or default to "download.bin"
                      var defaultName = moment().format('DD MMM YYYY');
                      if (angular.isDefined($scope.dataPdf.dataHttp.fecha)) {
                        defaultName = moment($scope.dataPdf.dataHttp.fecha).format('DD MMM YYYY');
                      }

                      var filename = headers['x-filename'] || defaultName + '.pdf';

                      // Determine the content type from the header or default to "application/octet-stream"
                      var contentType = headers['content-type'] || octetStreamMime;

                      try
                      {
                        // Try using msSaveBlob if supported
                        console.log("Trying saveBlob method ...");
                        blob = new Blob([data], { type: contentType });
                        if(navigator.msSaveBlob)
                          navigator.msSaveBlob(blob, filename);
                        else {
                          // Try using other saveBlob implementations, if available
                          var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
                          if(saveBlob === undefined) throw "Not supported";
                          saveBlob(blob, filename);
                        }
                        console.log("saveBlob succeeded");
                        success = true;
                        successFn();
                      } catch(ex)
                      {
                        console.log("saveBlob method failed with the following exception:");
                        console.log(ex);
                      }

                      if(!success)
                      {
                        // Get the blob url creator
                        var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                        if(urlCreator)
                        {
                          // Try to use a download link
                          var link = document.createElement('a');
                          if('download' in link)
                          {
                            // Try to simulate a click
                            try
                            {
                              // Prepare a blob URL
                              console.log("Trying download link method with simulated click ...");
                              blob = new Blob([data], { type: contentType });
                              url = urlCreator.createObjectURL(blob);
                              link.setAttribute('href', url);

                              // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                              link.setAttribute("download", filename);

                              // Simulate clicking the download link
                              var event = document.createEvent('MouseEvents');
                              event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                              link.dispatchEvent(event);
                              console.log("Download link method with simulated click succeeded");
                              success = true;
                              successFn();

                            } catch(ex) {
                              console.log("Download link method with simulated click failed with the following exception:");
                              console.log(ex);
                            }
                          }

                          if(!success)
                          {
                            // Fallback to window.location method
                            try
                            {
                              // Prepare a blob URL
                              // Use application/octet-stream when using window.location to force download
                              console.log("Trying download link method with window.location ...");
                              blob = new Blob([data], { type: octetStreamMime });
                              url = urlCreator.createObjectURL(blob);
                              window.location = url;
                              console.log("Download link method with window.location succeeded");
                              success = true;
                              successFn();
                            } catch(ex) {
                              console.log("Download link method with window.location failed with the following exception:");
                              console.log(ex);
                            }
                          }

                        }
                      }

                      if(!success)
                      {
                        // Fallback to window.open method
                        console.log("No methods worked for saving the arraybuffer, using last resort window.open");
                        window.open(httpPath, '_blank', '');
                        errorFn();
                      }
                    })
                  .error(function(data, status) {
                    console.log("Request failed with status: " + status);
                    errorFn();
                    // Optionally write the error out to scope
                    $scope.errorDetails = "Request failed with status: " + status;
                  });
                };

              }]
        };
    }]);
})();
